module.exports = __webpack_public_path__ + "static/media/ic-close.66ec4b88.svg";